const pearl = {
  pearl: 'لؤلؤة',
  amountTips: '* الحد الأدنى لعدد اللؤلؤة الإرسال: {{ num }}',
  selectUserTips: 'أدخل حساب المستلم',
  inputAmountTips: 'أدخل المبلغ الذي تريد إرساله',
};

export default {
  title: 'إرسال',
  success: 'إرسال بنجاح',
  transfer: 'إرسال',
  transfering: 'إرسال',
  successTips: 'يرجى التحقق من بطاقة الهوية والمبلغ الذي أرسلته .',
  sellResultTitle: 'للعملة ذهبية',
  sellSuccessMain: 'تم التبادل بنجاح',
  sellSuccessDescription: 'يرجى التحقق من الهوية والمبلغ الذي تريد إرساله',
  sellFailureDescription:
    'المعاملات الحالية غير طبيعية، يرجى الانتقال إلى تفاصيل المعاملات للتحقق من النتائج',
  pearl,
};
